import { cva } from 'class-variance-authority';
export const navVariants = cva('cmp-nav', {
    variants: {
        orient: {
            horizontal: 'cmp-nav-horizontal',
            vertical: 'cmp-nav-vertical',
        },
        appereance: {
            tab: 'cmp-nav-tab',
            segment: 'cmp-nav-segment',
            menu: 'cmp-nav-menu',
        },
        size: {
            small: 'cmp-nav-small',
            medium: 'cmp-nav-medium',
        },
    },
    defaultVariants: {
        orient: 'horizontal',
        appereance: 'tab',
        size: 'medium',
    },
});
//# sourceMappingURL=variants.js.map